import './cart.css';

const Cart = () => {
    return (
        <section className="cart-section">
            <div className="wrapper">
                <h2>Your Cart</h2>
            </div>
        </section>
    )
}

export default Cart;